/*global paypal*/

import App from 'app/app.js';
import paypalTemplate from './paypal.html';
import paypalCheckout from 'braintree-web/paypal-checkout';

class PaypalButtonController {
  isInitialized = false;
  isStudentDetailsModalOpened = false;
  isSupported = window.paymentDisplayPaypalFlag === 'Y';

  constructor(
    $rootScope,
    $scope,
    ShoppingCartStore,
    RouterService,
    ErrorLogService,
    StatsdService,
    AnalyticsService,
    JobStore,
    PaymentService,
    ContentStore,
    loggerService,
    StudentDetailService
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.ShoppingCartStore = ShoppingCartStore;
    this.clientToken = ShoppingCartStore.getClientAuthorization().clientToken;
    this.RouterService = RouterService;
    this.ErrorLogService = ErrorLogService;
    this.loggerService = loggerService;
    this.StatsdService = StatsdService;
    this.AnalyticsService = AnalyticsService;
    this.JobStore = JobStore;
    this.PaymentService = PaymentService;
    this.ContentStore = ContentStore;
    this.StudentDetailService = StudentDetailService;
  }

  $onInit() {
    if (!this.isSupported) {
      console.debug("Browser doesn't support paypal, skipping");
      return;
    }
    const paymentInstancePromise = this.PaymentService.getPaymentInstancePromise();
    // eslint-disable-next-line promise/catch-or-return
    paymentInstancePromise.then((clientInstance, err) => {
      this.initPayPal(clientInstance, err);
    });
  }

  // eslint-disable-next-line max-lines-per-function
  initPayPal = (clientInstance, err) => {
    const paypalSdkobj = {
      components: 'buttons', // Needed to display the message underneath the pay later button
      currency: this.JobStore.getCurrency(),
      intent: 'capture',
      'disable-funding': 'card'
    };
    if (window.buyerLocation) {
      paypalSdkobj['buyer-country'] = 'US';
    }
    if (window.buyerLocation) {
      paypalSdkobj['buyer-country'] = 'US';
    }
    if (err || window.braintreeAllPaymentsFailFlag === true) {
      const paymentError = err || 'All Payments loading failed';
      this.ErrorLogService(paymentError, 'Braintree client initialization error');
      this.loggerService.error(paymentError, 'Braintree client initialization error');
      this.StatsdService.incrementCounter('BRAINTREE_CLIENT_INITIALIZATION_FAILURE');
      return;
    }

    if (window.paymentDisplayPaypalFlag === 'Y') {
      paypalCheckout.create(
        {
          client: clientInstance
        },
        // eslint-disable-next-line max-lines-per-function
        (paypalCheckoutErr, paypalCheckoutInstance) => {
          if (window.braintreePaypalPaylaterFailFlag === true) {
            const paymentError = paypalCheckoutErr || 'paypal loading failed';
            this.ErrorLogService(paymentError, 'Paypal initialization error');
            this.loggerService.error(paymentError, 'Paypal initialization error');
            this.StatsdService.incrementCounter('PAYPAL_INITIALIZATION_FAILURE');
            return;
          }

          // eslint-disable-next-line max-lines-per-function
          paypalCheckoutInstance.loadPayPalSDK(paypalSdkobj, () => {
            // eslint-disable-next-line promise/catch-or-return
            paypal
              .Buttons({
                fundingSource: paypal.FUNDING.PAYPAL,
                style: {
                  height: 55
                },

                createOrder: () => {
                  return paypalCheckoutInstance.createPayment({
                    flow: 'checkout', // Required
                    amount: this.ShoppingCartStore.getTotal(), // Required
                    currency: this.JobStore.getCurrency(), // Required, must match the currency passed in with loadPayPalSDK
                    intent: 'capture', // Must match the intent passed in with loadPayPalSDK
                    enableShippingAddress: true,
                    shippingAddressEditable: false
                  });
                },

                onClick: (data, actions) => {
                  this.$rootScope.$emit('paypalClicked');
                  this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYPAL_START);
                  this.preCheckout && this.preCheckout();
                  return this._handleClick(actions);
                },

                onApprove: (data) => {
                  return paypalCheckoutInstance.tokenizePayment(data, (err, payload) => {
                    // Submit `payload.nonce` to your server
                    this.paymentSource = data.paymentSource;
                    const { email, firstName, lastName } = payload.details;
                    const paymentAddress = { ...payload.details.shippingAddress, email, firstName, lastName };
                    this.ShoppingCartStore.setPayPal(payload, this.requestAddress ? paymentAddress : null);
                    this.successPayment();
                  });
                },

                onCancel: (data) => {
                  this.$rootScope.$emit('ExternalPaymentReturn');
                  this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYPAL_CANCEL);
                  console.warn('PayPal payment cancelled', JSON.stringify(data, 0, 2));
                },

                onError: (err) => {
                  this.$rootScope.$emit('ExternalPaymentReturn');
                  this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYPAL_ERROR);
                  this.ErrorLogService(err, 'PayPal error');
                  this.loggerService.error(err, 'PayPal error');
                  console.error('Failed to load paypal', err);
                }
              })
              .render('#paypal-button')
              .then(() => {});
          });
          this.initialized();
        }
      );
    }
    this.initialized();
  };

  _handleClick = (actions) => {
    if (this.express && this.StudentDetailService.shouldOpenStudentDetailModal() && !this.isStudentDetailsModalOpened) {
      this.isStudentDetailsModalOpened = true;
      this.StudentDetailService.openStudentDetailModalWithCallback(() => this.RouterService.goToShoppingCart());
      return actions.reject();
    }

    if (this.preCheckoutValidation) {
      return this.preCheckoutValidation();
    }
  };

  initialized = () => {
    this.isInitialized = true;
    this.$scope.$applyAsync();
  };

  successPayment = () => {
    if (this.express) {
      this.RouterService.goToBillingInfo();
    } else {
      this.RouterService.goToReviewOrder();
    }
    this.$rootScope.$digest();
  };
}

PaypalButtonController.$inject = [
  '$rootScope',
  '$scope',
  'ShoppingCartStore',
  'RouterService',
  'ErrorLogService',
  'StatsdService',
  'AnalyticsService',
  'JobStore',
  'PaymentService',
  'ContentStore',
  'loggerService',
  'StudentDetailService'
];

App.component('ltPaypalButton', {
  template: paypalTemplate,
  bindings: {
    selected: '<',
    preCheckout: '&?',
    preCheckoutValidation: '&?',
    express: '<',
    requestAddress: '<'
  },
  transclude: true,
  controller: PaypalButtonController,
  controllerAs: 'paypal'
});
